import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs'
import { get } from 'lodash-es'

//财务账号
export const finAccountPageList = (current, pageSize, params) => {
    return request(`${UrlConfig.PlusFmsWeb.FinAccountPageList}?current=${current}&pageSize=${pageSize}`, {
        method: METHODS.POST,
        data: params,
    }).then((resp: any) => {
        const records = get(resp, 'list', [])
        const total = get(resp, 'count', 0)
        return { records, total }
    })
}
export const finAccountList = (params) => {
    return request(`${UrlConfig.PlusFmsWeb.FinAccountList}`, {
        method: METHODS.POST,
        data: params,
    })
}
export const acquireFinAccountBatchFromKd = (data) => {
    return request(`${UrlConfig.PlusFmsWeb.AcquireFinAccountBatchFromKd}`, {
        method: METHODS.POST,
        data,
    })
}
export const finAccountPageOption = data => {
    return request(UrlConfig.PlusFmsWeb.FinAccountPageOption, {
        method: METHODS.POST,
        data,
    }).then((resp: any) => {
        return resp
    })
}
export const finAccountPageSaveOrUpdate = data => {
    return request(UrlConfig.PlusFmsWeb.FinAccountPageSaveOrUpdate, {
        method: METHODS.POST,
        data,
    }).then((resp: any) => {
        return resp
    })
}
/**
 * 打卡配置列表
 */
export const billSetInfoListPage = (current, pageSize, params) => {
    return request(`${UrlConfig.Kingdee.BillSetInfoList}?pageId=${current}&pageSize=${pageSize}`, {
        method: METHODS.POST,
        data: params,
    }).then((resp: any) => {
        const records = get(resp, 'list', [])
        const total = get(resp, 'count', 0)
        return { records, total }
    })
}
export const queryOrgDataByBillId = data => {
    return request(UrlConfig.Kingdee.QueryOrgDataByBillId, {
        method: METHODS.POST,
        data,
    }).then((resp: any) => {
        return resp
    })
}
//企业认证
export const esignCommonFindCompanyConfig = (current, pageSize, params) => {
    return request(`${UrlConfig.Esign.EsignCommonFindCompanyConfig}?crrunt=${current}&size=${pageSize}`, {
        method: METHODS.POST,
        data: params,
    }).then((resp: any) => {
        const records = get(resp, 'list', [])
        const total = get(resp, 'count', 0)
        return { records, total }
    })
}
//财务主体
export const esigncompanyconfig = (current, pageSize, params) => {
  return request(`${UrlConfig.Esign.esigncompanyconfig}?crrunt=${current}&size=${pageSize}`, {
      method: METHODS.POST,
      data: params,
  }).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
  })
}
export const esignCommonList = () => {
    return request(`${UrlConfig.Esign.EsignCommonList}`, {
        method: METHODS.POST,
        data: {}
    })
}
export const esignCommonApply = id => {
    return request(`${UrlConfig.Esign.EsignCommonApply}/${id}`, {
        method: METHODS.POST,
    })
}
export const esignCommonDealetCompny = id => {
    return request(`${UrlConfig.Esign.EsignCommonDealetCompny}/${id}`, {
        method: METHODS.DELETE,
    })
}
export const esignCommonSaveOrUpdateCompny = (data) => {
    return request(`${UrlConfig.Esign.EsignCommonSaveOrUpdateCompny}`, {
        method: METHODS.POST,
        data,
    })
}
export const esignCommonUpdateById = (data) => {
    return request(`${UrlConfig.Esign.EsignCommonUpdateById}`, {
        method: METHODS.POST,
        data,
    })
}
export const EsignCommonUpdateStateToUnAudit = (data) => {
    return request(`${UrlConfig.Esign.EsignCommonUpdateStateToUnAudit}`, {
        method: METHODS.POST,
        data,
    })
}
export const queryKdCompanyInfo = (data) => {
    return request(`${UrlConfig.Kingdee.QueryKdCompanyInfo}`, {
        method: METHODS.POST,
        data,
    })
}
//收款规则
export const prodReceiptRulePageList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.Fms.ProdReceiptRulePageList}?pageId=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const prodReceiptRulePageDelete = data => {
    return request(`${UrlConfig.Fms.ProdReceiptRulePageAdd}/${data}`, {
      method: METHODS.DELETE,
    })
  }
  export const prodReceiptRulePageAdd = data => {
    return request(UrlConfig.Fms.ProdReceiptRulePageAdd, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const prodReceiptRulePageUpdateById = data => {
    return request(UrlConfig.Fms.ProdReceiptRulePageUpdateById, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const prodReceiptRulePageStateChange = data => {
    return request(UrlConfig.Fms.ProdReceiptRulePageStateChange, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const prodReceiptRulePageprodReceiptRuleDtl = (current, pageSize, params) => {
    return request(
      `${UrlConfig.Fms.ProdReceiptRulePageprodReceiptRuleDtl}?pageId=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const prodReceiptRulePageSaveOrDeleteBatch = data => {
    return request(UrlConfig.Fms.ProdReceiptRulePageSaveOrDeleteBatch, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  //收款计算内容配置
export const transactionCalPageList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.Fms.TransactionCalPageList}?pageId=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const transactionCalDtlPageList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.Fms.TransactionCalDtlPageList}?pageId=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const transactionCalPage = data => {
    return request(UrlConfig.Fms.TransactionCalPage, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const transactionCalDtlPageSaveOrUpdateEntity = data => {
    return request(UrlConfig.Fms.TransactionCalDtlPageSaveOrUpdateEntity, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const transactionCalPageUpdateById = data => {
    return request(UrlConfig.Fms.TransactionCalPageUpdateById, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  //打印配置
export const billPrintConfigPageList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.PlusFmsWeb.BillPrintConfigPageList}?current=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const billPrintConfigSavePage = data => {
    return request(UrlConfig.PlusFmsWeb.BillPrintConfigSavePage, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const billPrintConfigUpdatePage = data => {
    return request(UrlConfig.PlusFmsWeb.BillPrintConfigUpdatePage, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const billPrintConfigStateActionPage = data => {
    return request(UrlConfig.PlusFmsWeb.BillPrintConfigStateActionPage, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  // 收款核销
  export const receiptWriteOffPageList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.PlusFmsWeb.ReceiptWriteOffPageList}?current=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const receiptWriteOffSaveOrUpdateEntity = data => {
    return request(UrlConfig.PlusFmsWeb.ReceiptWriteOffSaveOrUpdateEntity, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptWriteOffById = data => {
    return request(`${UrlConfig.PlusFmsWeb.ReceiptWriteOffById}?id=${data.id}`, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptWriteOffDisable = id => {
    return request(`${UrlConfig.PlusFmsWeb.ReceiptWriteOffDisable}${id}`, {
      method: METHODS.GET,
    })
  }
  export const receiptWriteOffEnable = id => {
    return request(`${UrlConfig.PlusFmsWeb.ReceiptWriteOffEnable}${id}`, {
      method: METHODS.GET,
    })
  }
  export const receiptWriteOffDelete = id => {
    return request(`${UrlConfig.PlusFmsWeb.ReceiptWriteOffDelete}${id}`, {
      method: METHODS.DELETE,
    })
  }
  // 收退款关系
  export const chargebackRelationshipList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.PlusFmsWeb.ChargebackRelationshipList}?current=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const chargebackRelationshipSaveOrUpdate = data => {
    return request(UrlConfig.PlusFmsWeb.ChargebackRelationshipSaveOrUpdate, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const chargebackRelationshipById = id => {
    return request(UrlConfig.PlusFmsWeb.ChargebackRelationshipById+`?id=${id}`, {
      method: METHODS.POST,
    }).then((resp: any) => {
      return resp
    })
  }
  export const chargebackRelationshipDisabled = id => {
    return request(`${UrlConfig.PlusFmsWeb.ChargebackRelationshipDisabled}?id=${id}`, {
      method: METHODS.GET,
    })
  }
  export const chargebackRelationshipEnabled = id => {
    return request(`${UrlConfig.PlusFmsWeb.ChargebackRelationshipEnabled}?id=${id}`, {
      method: METHODS.GET,
    })
  }
  export const chargebackRelationshipDelete = id => {
    return request(`${UrlConfig.PlusFmsWeb.ChargebackRelationshipDelete}?id=${id}`, {
      method: METHODS.GET,
    })
  }
  // 收款计划
  export const receiptRulesPlanMainPageList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.PlusFmsWeb.ReceiptRulesPlanMainPageList}?pageId=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const receiptRulesPlanMain = data => {
    return request(UrlConfig.PlusFmsWeb.ReceiptRulesPlanMain, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const getReceiptRulesPlanMain = id => {
    return request(`${UrlConfig.PlusFmsWeb.ReceiptRulesPlanMain}/${id}`, {
      method: METHODS.GET,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptRulesPlanMainUpdateById = data => {
    return request(UrlConfig.PlusFmsWeb.ReceiptRulesPlanMainUpdateById, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptRulesPlanMainRulesPlanDetail = data => {
    return request(UrlConfig.PlusFmsWeb.ReceiptRulesPlanMainRulesPlanDetail, {
      method: METHODS.POST,
      params: data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptRulesPlanRulesFullPlanDetail = data => {
    return request(UrlConfig.PlusFmsWeb.ReceiptRulesPlanRulesFullPlanDetail, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptRulesPlanRulesBranchPlan = data => {
    return request(UrlConfig.PlusFmsWeb.ReceiptRulesPlanRulesBranchPlan, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptRulesPlanAddRulesBranchPlanDetail = data => {
    return request(UrlConfig.PlusFmsWeb.ReceiptRulesPlanAddRulesBranchPlanDetail, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptRulesPlanMainIsEnabled = data => {
    return request(UrlConfig.PlusFmsWeb.ReceiptRulesPlanMainIsEnabled, {
      method: METHODS.GET,
      params: data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const planCommonControllerRule = (data) => {
    return request(UrlConfig.PlusFmsWeb.PlanCommonControllerRule, {
      method: METHODS.GET,
      params: data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const planCommonControllerFindRelevanceItem = () => {
    return request(UrlConfig.PlusFmsWeb.PlanCommonControllerFindRelevanceItem, {
      method: METHODS.GET,
    }).then((resp: any) => {
      return resp
    })
  }
  export const planCommonControllerFindFetchType = () => {
    return request(UrlConfig.PlusFmsWeb.PlanCommonControllerFindFetchType, {
      method: METHODS.GET,
    }).then((resp: any) => {
      return resp
    })
  }
  export const planCommonFindSpecialRuleVariableById = (id) => {
    return request(UrlConfig.PlusFmsWeb.PlanCommonFindSpecialRuleVariableById, {
      method: METHODS.GET,
      params: {
        id
      }
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptRulesPlanRulesBranchPlanDelete = id => {
    return request(`${UrlConfig.PlusFmsWeb.ReceiptRulesPlanRulesBranchPlan}/${id}`, {
      method: METHODS.DELETE,
    })
  }
  export const receiptRulesPlanRulesDelete = id => {
    return request(`${UrlConfig.PlusFmsWeb.ReceiptRulesPlanRulesDelete}/${id}`, {
      method: METHODS.DELETE,
    })
  }
  export const receiptRulesPlanBranchDelete = id => {
    return request(`${UrlConfig.PlusFmsWeb.ReceiptRulesPlanBranchDelete}/${id}`, {
      method: METHODS.DELETE,
    })
  }
  export const variableRetrieval = (url, params) => {
    return request('/plus-fms-web' + url, {
      method: METHODS.GET,
      params,
    }).then((resp: any) => {
      return resp
    })
  }
  export const receiptFindSpecialRuleVariable = () => {
    return request(UrlConfig.PlusFmsWeb.ReceiptFindSpecialRuleVariable, {
      method: METHODS.GET,
    }).then((resp: any) => {
      return resp
    })
  }
  export const specialRulesDetailIsEnabled = (data) => {
    return request(UrlConfig.PlusFmsWeb.SpecialRulesDetailIsEnabled, {
      method: METHODS.GET,
      params: data
    }).then((resp: any) => {
      return resp
    })
  }
  export const specialRulesLabelAdd = data => {
    return request(UrlConfig.PlusFmsWeb.SpecialRulesLabelAdd, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const specialRulesLabelUpdateById = data => {
    return request(UrlConfig.PlusFmsWeb.SpecialRulesLabelUpdateById, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const specialRulesDetailAdd = data => {
    return request(UrlConfig.PlusFmsWeb.SpecialRulesDetailAdd, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const specialRulesDetailUpdateById = data => {
    return request(UrlConfig.PlusFmsWeb.SpecialRulesDetailUpdateById, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const specialRulesLabelList = data => {
    return request(UrlConfig.PlusFmsWeb.SpecialRulesLabelList, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const specialRulesLabelDelete = id => {
    return request(`${UrlConfig.PlusFmsWeb.SpecialRulesLabelAdd}/${id}`, {
      method: METHODS.DELETE,
    })
  }
  export const specialRulesDetailDelete = id => {
    return request(`${UrlConfig.PlusFmsWeb.SpecialRulesDetailAdd}/${id}`, {
      method: METHODS.DELETE,
    })
  }
  export const specialRulesLabelPageList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.PlusFmsWeb.SpecialRulesLabelPageList}?pageId=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const getBankList = data => {
    return request(UrlConfig.Platform.GetBankList, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const getBankAreaList = data => {
    return request(UrlConfig.Platform.GetBankAreaList, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const getBankBranchList = data => {
    return request(UrlConfig.Platform.GetBankBranchList, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  // 贷款机构 
  export const lendingInstitutionsList = (current, pageSize, params) => {
    return request(
      `${UrlConfig.PlusFmsWeb.LendingInstitutionsList}?current=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const lendingInstitutionsAdd = data => {
    return request(UrlConfig.PlusFmsWeb.LendingInstitutions, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const lendingInstitutionsEdit = data => {
    return request(UrlConfig.PlusFmsWeb.LendingInstitutionsEdit, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const lendingInstitutionsSearch = data => {
    return request(UrlConfig.PlusFmsWeb.LendingInstitutionsSearch, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const lendingInstitutionsChangeState = (state, data) => {
    console.log(state,'state')
    return request(state ? UrlConfig.PlusFmsWeb.LendingInstitutionsEnable :  UrlConfig.PlusFmsWeb.LendingInstitutionsDisable, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  //白名单
  export const whiteConfigFindResponseListByPage = (current, pageSize, params) => {
    return request(
      `${UrlConfig.PlusFmsWeb.WhiteConfigFindResponseListByPage}?current=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const whiteConfigUpdateEnabled = data => {
    return request(UrlConfig.PlusFmsWeb.WhiteConfigUpdateEnabled, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const whiteConfigSaveOrUpdateByRequest = data => {
    return request(UrlConfig.PlusFmsWeb.WhiteConfigSaveOrUpdateByRequest, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const findWhiteNodeResponseListByRequest = data => {
    return request(UrlConfig.PlusFmsWeb.FindWhiteNodeResponseListByRequest, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const findAuditPassResponseListByPage = (current, pageSize, params) => {
    return request(
      `${UrlConfig.PlusFmsWeb.FindAuditPassResponseListByPage}?current=${current}&pageSize=${pageSize}`,
      {
        method: METHODS.POST,
        data: params,
      }
    ).then((resp: any) => {
      const records = get(resp, 'list', [])
      const total = get(resp, 'count', 0)
      return { records, total }
    })
  }
  export const startReceiptWhiteApplyProcess = data => {
    return request(UrlConfig.PlusFmsWeb.StartReceiptWhiteApplyProcess, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const findOrderAccountDtlResponseByOrderIdRequest = data => {
    return request(UrlConfig.PlusFmsWeb.FindOrderAccountDtlResponseByOrderIdRequest, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }
  export const whiteApplyFindDetailResponseByRequest = data => {
    return request(UrlConfig.PlusFmsWeb.WhiteApplyFindDetailResponseByRequest, {
      method: METHODS.POST,
      data,
    }).then((resp: any) => {
      return resp
    })
  }